import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneValidator(control: FormControl) {
  const phoneRegex = /^\d{5,16}$/;
  if (control.value && !control.value.match(phoneRegex)) {
    return { phone: true };
  }
  return null;
}


export function indiaPhoneValidator(control: FormControl) {
  const phoneRegex = /^\d{10}$/;
  if (control.value && !control.value.match(phoneRegex)) {
    return { phone: true };
  }
  return null;
}
